import {
  compose,
  setDisplayName,
  lifecycle,
} from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchPreferences } from 'store/preferences/actions'
import {
  selectPreferences,
  selectFetchPreferencesStatus,
  selectStoreId,
  selectStoreLocatorPreferences,
  selectFontFamily,
} from 'store/preferences/selectors'

const mapStateToProps = (state) => ({
  preferences: selectPreferences(state),
  fetchPreferencesStatus: selectFetchPreferencesStatus(state),
})

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({ fetchPreferences }, dispatch)
)

export const withFontFamilies = () => (
  compose(
    connect(
      (state) => ({
        fontFamily: selectFontFamily(state),
      }),
    ),
  )
)

export const withPreferences = () => (
  compose(
    setDisplayName('Preferences'),
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle({
      componentDidMount() {
        if (!this.props.fetchPreferencesStatus.isSuccess) {
          this.props.fetchPreferences()
        }
      },
    }),
  )
)

export const withStoreLocatorPreferences = () => (
  compose(
    setDisplayName('StoreLocatorPreferences'),
    connect(
      (state) => ({
        storeLocatorPreferences: selectStoreLocatorPreferences(state),
      }),
    ),
  )
)

export const withStoreId = () => (
  compose(
    setDisplayName('WithStoreId'),
    connect(
      (state) => ({
        storeId: selectStoreId(state),
      }),
    ),
  )
)



// WEBPACK FOOTER //
// ./src/store/preferences/withPreferences.js